import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  AppBar,
  Toolbar,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Card,
  Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import SellIcon from "@mui/icons-material/Sell";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import HouseIcon from "@mui/icons-material/House";
import BusinessIcon from "@mui/icons-material/Business";
import Logout from "@mui/icons-material/Logout";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import CreditCardIcon from '@mui/icons-material/CreditCard';

import SearchIcon from "@mui/icons-material/Search";        
import GavelIcon from "@mui/icons-material/Gavel";          
import HandshakeIcon from "@mui/icons-material/Handshake";   

import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./../../Api/ApiUrls";
import { AuthContext } from "./../../AuthContext/AuthContext";

const WorkerDetail = () => { 
  const navigate = useNavigate();
  
  const { userId, logout } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [propertyCounts, setPropertyCounts] = useState({
    postProperty: 0,
    sellProperty: 0,
    rentProperty: 0,
    leaseProperty: 0,
    vendors: 0,
    wanted: 0,
    bankAuction: 0,
    jvbuilt: 0,
  });

  const menuItems = [
    {
      text: 'Profile',
      icon: <PersonIcon />,
      action: () => navigate(`/user-profile/${userId}`)
    },
    {
      text: 'Subscription Plans',
      icon: <CreditCardIcon />,
      action: () => navigate("/user-subscription")
    },
    {
      text: 'Sell Properties',
      icon: <SellIcon />,
      count: propertyCounts.sellProperty,
      action: () => navigate("/user-buy")
    },
    {
      text: 'Best Deal Properties',
      icon: <LocalOfferIcon />,
      count: propertyCounts.postProperty,
      action: () => navigate("/user-bestdeals")
    },
    {
      text: 'Rent Properties',
      icon: <HouseIcon />,
      count: propertyCounts.rentProperty,
      action: () => navigate("/user-rent")
    },
    {
      text: 'Lease Properties',
      icon: <BusinessIcon />,
      count: propertyCounts.leaseProperty,
      action: () => navigate("/user-lease")
    },
    {
      text: 'Vendor Registration',
      icon: <AssignmentIndIcon />,
      count: propertyCounts.vendors,
      action: () => navigate("/user-vendors")
    },
    {
      text: 'Wanted Properties',
      icon: <SearchIcon />,
      count: propertyCounts.wanted || 0,
      action: () => navigate("/user-wanted")
    },
    {
      text: 'Bank Auction Properties',
      icon: <GavelIcon />,
      count: propertyCounts.bankAuction || 0,
      action: () => navigate("/user-bankauction")
    },
    {
      text: 'Built Suit Properties',
      icon: <HandshakeIcon />,
      count: propertyCounts.wanted || 0,
      action: () => navigate("/builtSuitProperties")
    },
  ];

useEffect(() => {
  if (!userId) return;

  // Fetch user data
  fetch(`${BASE_URL}/users/${userId}/`)
    .then((response) => response.json())
    .then((data) => {
      setUserData(data);
    })
    .catch((error) => console.error("Error fetching user data:", error));

  // Fetch property data for regular properties
  fetch(`${BASE_URL}/property/`)
    .then(response => response.json())
    .then(data => {
      const userProperties = data.filter(prop => prop.user_id == userId);

      const counts = {
        postProperty: userProperties.filter(prop => prop.type === "best-deal").length,
        sellProperty: userProperties.filter(prop => prop.type === "sell").length,
        rentProperty: userProperties.filter(prop => prop.type === "rent").length,
        leaseProperty: userProperties.filter(prop => prop.type === "lease").length,
        wanted: 0,
        bankAuction: 0, 
        jvbuilt: userProperties.filter(prop => 
          prop.type === "jvbuilt" || 
          prop.type === "built-suit" || 
          prop.type === "built_suit" ||
          prop.type === "builtsuit"
        ).length,
        vendors: 0
      };

      // Fetch vendors data
      fetch(`${BASE_URL}/vendors/`)
        .then(vendorResponse => vendorResponse.json())
        .then(vendorData => {
          const userVendors = vendorData.filter(vendor => vendor.user_id == userId);
          counts.vendors = userVendors.length;
          
          // Fetch Wanted Properties
          return fetch(`https://landnest.net:81/property-request/?userId=${userId}`);
        })
        .then(wantedResponse => wantedResponse.json())
        .then(wantedData => {
          // Filter wanted properties by user_id
          const userWantedProperties = Array.isArray(wantedData) 
            ? wantedData.filter(item => item.user_id == userId)
            : [];
          counts.wanted = userWantedProperties.length;
          
          // Fetch Bank Auction Properties
          return fetch(`https://landnest.net:81/auction-property/?userId=${userId}`);
        })
        .then(auctionResponse => auctionResponse.json())
        .then(auctionData => {
          // Filter bank auction properties by user_id
          const userAuctionProperties = Array.isArray(auctionData) 
            ? auctionData.filter(item => item.user_id == userId)
            : [];
          counts.bankAuction = userAuctionProperties.length;
          
          // Set the updated counts
          console.log("Final counts:", counts);
          setPropertyCounts(counts);
        })
        .catch(error => console.error("Error fetching additional property data:", error));
    })
    .catch(error => console.error("Error fetching property data:", error));
}, [userId]);

  const handleLogout = async () => {
    console.log('🔄 Logout process initiated');
    
    try {
      const userId = localStorage.getItem('user_id');
      
      if (!userId) {
        console.warn('⚠️ No user_id found in localStorage, proceeding with client-side logout only');
      } else {
        console.log(`📤 Sending logout request for user_id: ${userId}`);
        
        const response = await fetch(`${BASE_URL}/logout/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ user_id: userId })
        });

        if (response.ok) {
          console.log('✅ Logout API call successful - User session terminated on server');
        } else {
          console.warn(`⚠️ Logout API returned status: ${response.status} - ${response.statusText}`);
        }
      }
    } catch (error) {
      console.error('❌ Logout API error:', error.message);
      console.log('🔄 Continuing with client-side logout despite API error');
    } finally {
      console.log('🧹 Cleaning up client-side authentication data');
      logout();
      console.log('🚀 Redirecting to home page');
      navigate("/");
      console.log('🎉 Logout process completed successfully');
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url('/construction4.png')
      `,
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed'
    }}>
      {/* Header with Back Button and Profile */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.2)'
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '16px',
            backgroundColor: 'rgba(255,255,255,0.1)',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.2)'
            }
          }}>
            <Avatar
              alt={userData?.username || "User"}
              src={userData?.profile ? `${BASE_URL}${userData.profile}` : ""}
              sx={{
                width: 36,
                height: 36,
                mr: 1.5,
                border: '2px solid rgba(255,255,255,0.3)'
              }}
            />
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#ffffff' }}>
                {userData?.username || "Loading..."}
              </Typography>
              <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.7rem' }}>
                {userData?.user_id ? `CUSTOMER${userData.user_id.toString().padStart(4, '0')}` : "Loading..."}
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Container
        sx={{
          py: 2,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5
        }}
      >
        {menuItems.map((item, index) => (
          <Card
            key={item.text}
            sx={{
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 24px rgba(0,0,0,0.15)'
              }
            }}
          >
            <ListItem
              button
              onClick={item.action}
              sx={{
                py: 2,
                px: 2,
                backgroundColor: 'rgba(255,255,255,0.3)',
                margin: '0',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.4)',
                }
              }}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  variant: 'body1',
                  fontWeight: 600,
                  color: '#333333'
                }}
              />
              {item.count !== undefined && (
                <Typography
                  variant="body2"
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    borderRadius: '12px',
                    px: 1.5,
                    py: 0.5,
                    minWidth: '24px',
                    textAlign: 'center'
                  }}
                >
                  {item.count}
                </Typography>
              )}
            </ListItem>
          </Card>
        ))}

        {/* Combined Logout and Version Info */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1,
          px: 2,
          mt: 'auto',
          mb: 1
        }}>
          <Button
            onClick={handleLogout}
            startIcon={<Logout />}
            sx={{
              color: 'error.main',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: 'rgba(255, 80, 80, 0.1)',
              }
            }}
          >
            Logout
          </Button>

          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            PropertyPro v1.0
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default WorkerDetail;